import { z } from 'zod';

const annotation = z.object({
  content: z.string(),
  order: z.number(),
});

export const chartConfiguration = z.object({
  takeaways: z.array(annotation),
  visible: z.boolean(),
  recommendations: z.optional(z.array(annotation)),
});

export type Annotation = z.infer<typeof annotation>;
export type ChartConfiguration = z.infer<typeof chartConfiguration>;
